// extracted by mini-css-extract-plugin
export default {"content":"AboutMe_content__3LRDV","textContent":"AboutMe_textContent__5E4N-","img":"AboutMe_img__p8oFL","animation_01":"AboutMe_animation_01__dLb2H"};